import './HArticleListItem.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage } from '~/schemes';
import { ArticleListItemModule } from '~/server-middleware/data-server/adapter/ACCOAdapter/@types';
import { resolveTourListAnchorAttrs } from '~/helpers/tour-list';

export const HArticleListItem = tsx.component({
  name: 'HArticleListItem',
  functional: true,
  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<
          ArticleListItemModule['properties'],
          AvailableLanguage
        >
      >,
      required: true,
    },
  },
  render(h, { props, parent }): VNode | VNode[] {
    const articleItem = props.value;
    if (!articleItem.title) return [];
    const tourListAttrs = resolveTourListAnchorAttrs(
      articleItem.url,
      'noopener noreferrer',
      parent,
    );
    return (
      <div
        key={articleItem.key}
        class={[
          'h-article-list-item',
          { 'h-article-list-item--has-link': !!articleItem.url },
        ]}>
        {articleItem.url && (
          <a
            class="h-article-list-item-link"
            href={tourListAttrs.href || undefined}
            target="_blank"
            rel={tourListAttrs.rel}
            {...{ attrs: { referrerpolicy: tourListAttrs.referrerpolicy } }}
          />
        )}
        <figure>
          <img
            src={articleItem.image?.derived.main?.url || ''}
            class="h-article-list-item-image"
          />
          {articleItem.caption && (
            <figcaption
              class={[
                'h-article-list-item-caption',
                { 'empty-value': !articleItem.caption },
              ]}>
              {articleItem.caption}
            </figcaption>
          )}
        </figure>
        <div class="h-article-list-item-headers">
          <div
            class={[
              'h-article-list-item-sub-title',
              { 'empty-value': !articleItem.subTitle },
            ]}>
            {articleItem.subTitle}
          </div>
          <div
            class={[
              'h-article-list-item-title',
              { 'empty-value': !articleItem.title },
            ]}>
            {articleItem.title}
          </div>
        </div>
        {articleItem.lead && (
          <div
            class={[
              'h-article-list-item-lead',
              { 'empty-value': !articleItem.lead },
            ]}>
            {articleItem.lead}
          </div>
        )}
      </div>
    );
  },
});
